var _g, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundedCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e4de4300-4bdd-4d8a-a245-4a55340a3635",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-rounded-calendar-hollow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,.5A4.50508,4.50508,0,0,1,27.5,5V23A4.50508,4.50508,0,0,1,23,27.5H5A4.50508,4.50508,0,0,1,.5,23V5A4.50508,4.50508,0,0,1,5,.5H23M23,0H5A5,5,0,0,0,0,5V23a5,5,0,0,0,5,5H23a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z",
    fill: "#333"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 14,
    height: 14,
    rx: 1.5,
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.25,
    y1: 9,
    x2: 10.25,
    y2: 5,
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 17.75,
    y1: 9,
    x2: 17.75,
    y2: 5,
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 11,
    x2: 21,
    y2: 11,
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 16.39708,
    y1: 13.73607,
    x2: 16.39708,
    y2: 15.94722,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14.29415,
    y1: 15.26393,
    x2: 16.39708,
    y2: 15.94722,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 15.0974,
    y1: 17.73607,
    x2: 16.39708,
    y2: 15.94722,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 17.69675,
    y1: 17.73607,
    x2: 16.39708,
    y2: 15.94722,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 15.26393,
    x2: 16.39708,
    y2: 15.94722,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedCalendar);
export default __webpack_public_path__ + "static/media/rounded-calendar.b91a582240c5777010c3cdd28f440dd9.svg";
export { ForwardRef as ReactComponent };